import { render, staticRenderFns } from "./select-province.vue?vue&type=template&id=98ae840c&scoped=true&"
import script from "./select-province.vue?vue&type=script&lang=js&"
export * from "./select-province.vue?vue&type=script&lang=js&"
import style0 from "./select-province.vue?vue&type=style&index=0&id=98ae840c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ae840c",
  null
  
)

export default component.exports